import { alpha, Box, Stack, styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledBox = styled(Box)(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  textAlign: 'left',
  textDecoration: 'none',
  borderRadius: theme.spacing(1),
  gap: theme.spacing(2),
  color: theme.palette.grey[50],
  background: `linear-gradient(360deg,
    ${alpha(theme.palette.grey[50], 0.02)} 0%,
    ${alpha(theme.palette.grey[50], 0.1)} 100%) ${theme.palette.grey[900]}`,
  '&:hover': {
    cursor: 'pointer',
    background: `linear-gradient(360deg,
      ${alpha(theme.palette.grey[50], 0.06)} 0%,
      ${alpha(theme.palette.grey[50], 0.15)} 100%) ${theme.palette.grey[900]}`,
    '& .arrow-right': {
      marginLeft: theme.spacing(0.5),
      transition: 'margin-left 0.2s ease-in-out',
    },
  },
}));

export const StyledLink = styled(Link)({
  height: '100%',
  textDecoration: 'none',
});

export const StyledTitle = styled(Typography)({
  fontSize: 18,
  fontWeight: 700,
  fontStyle: 'normal',
});

export const StyledSubtitleWrapper = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
});
